import Topbar from "./topbar";
import CategoriesBar from "./categoriesBar";
import popup from "./popup";
// import script from "./script"